import { Component, OnInit, Input } from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { CartService } from "../services/cart.service";
import { Observable } from "rxjs";
import { CartItem } from "src/app/modals/cart-item";
import { ProductService } from "../services/product.service";
import { ObservService } from "src/app/services/observ.service";
import { AlertServiceService } from "src/app/services/alerta.service";
import { MatDialog } from "@angular/material";
import { CartDialogComponent } from "../../pages/cart-dialog/cart-dialog.component";

@Component({
  selector: "app-shopping-widgets",
  templateUrl: "./shopping-widgets.component.html",
  styleUrls: ["./shopping-widgets.component.sass"],
})
export class ShoppingWidgetsComponent implements OnInit {
  products: Product[];
  indexProduct: number;

  public sidenavMenuItems: Array<any>;

  cartItems: any[] = [];
  @Input()
  set shoppingCartItems(value: any[]) {
    this.cartItems = value;
    this.observService.actualizarCarro.subscribe((x) => {
      if (x == 0) {
        this.cartItems.splice(0, this.cartItems.length);
      }
    });
    // //console.log(this.cartItems)
  }

  constructor(
    private cartService: CartService,
    public productService: ProductService,
    public observService: ObservService,
    private alert: AlertServiceService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {}
  ngAfterViewInit() {}
  public updateCurrency(curr) {
    this.productService.currency = curr;
  }

  public removeItem(item: any) {
    this.cartService.removeFromCart(item);
  }

  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }
  abrirDialogCart() {
    this.dialog.open(CartDialogComponent, {
      data: null,
      panelClass: "product-dialog",
      width: "800px",
      // height: "100%",
      // position: {
      //   right: "0",
      // },
    });
  }
}
